export default "{\n    \"title\": \"Assign to a Staff Member\",\n    \"subtitle\": \"Create and assign a work order to a staff member.\"\n}\n"